import { hydraUiApi, useHydraUIAPIQuery } from '@/services/api';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';

/** The query key prefix for the account's add-ons, invalidated after an add-on change. */
export const ADDONS_QUERY_KEY = ['getAddons'];

/**
 * The add-ons a Flex account can buy and the ones it holds.
 *
 * Disabled for other plans, which the endpoint refuses, and when `isEnabled` is false.
 */
export function useAddons({ isEnabled = true }: { isEnabled?: boolean } = {}) {
  const { account } = useAuth();

  return useHydraUIAPIQuery({
    queryKey: [...ADDONS_QUERY_KEY, { params: { account_id: account.id } }],
    queryFn: ({ signal }) =>
      hydraUiApi.billing.getAddons({
        params: { path: { account_id: String(account.id) } },
        signal,
      }),
    queryConfig: { enabled: isEnabled && isFlexPlan(account) },
  });
}
